import styled from 'styled-components';

import { GenericDiv } from 'commonStyles';

export const LeftWrap = styled.div`
	width: 48%;
	img {
		opacity: 0.5;
		max-height: 100%;
		display: inline-block;
	}
`;

export const OrangeBorderSmall = styled.div`
	border-radius: 18px;
	background: #f76162;
	margin: 8px 0 7px;
	width: 20px;
	height: 2px;
`;

export const LogoWrap = styled(GenericDiv)`
	height: 20px;
`;

export const Link = styled.a`
	font-size: 12px;
	line-height: 14px;
	margin-bottom: 5px;
`;
